/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompanyFinancialsResponse,
  Problem,
} from '../models/index';
import {
    CompanyFinancialsResponseFromJSON,
    CompanyFinancialsResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
} from '../models/index';

/**
 * CompanyFinancialsApi - interface
 * 
 * @export
 * @interface CompanyFinancialsApiInterface
 */
export interface CompanyFinancialsApiInterface {
    /**
     * Generates and downloads a styled Excel workbook containing a Claims sheet (per-claim rows with currency-formatted cells) and a Monthly sheet (receivables, payments, and revenue grids). 
     * @summary Export financials report to Excel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyFinancialsApiInterface
     */
    exportCompanyFinancialsExcelRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Generates and downloads a styled Excel workbook containing a Claims sheet (per-claim rows with currency-formatted cells) and a Monthly sheet (receivables, payments, and revenue grids). 
     * Export financials report to Excel
     */
    exportCompanyFinancialsExcel(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Returns a comprehensive financial report for the authenticated user\'s company. Includes per-claim financial rows and monthly breakdowns for receivables, payments, and revenue – all grouped by claim creation month. 
     * @summary Get aggregated financials report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyFinancialsApiInterface
     */
    getCompanyFinancialsReportRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyFinancialsResponse>>;

    /**
     * Returns a comprehensive financial report for the authenticated user\'s company. Includes per-claim financial rows and monthly breakdowns for receivables, payments, and revenue – all grouped by claim creation month. 
     * Get aggregated financials report
     */
    getCompanyFinancialsReport(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyFinancialsResponse>;

}

/**
 * 
 */
export class CompanyFinancialsApi extends runtime.BaseAPI implements CompanyFinancialsApiInterface {

    /**
     * Generates and downloads a styled Excel workbook containing a Claims sheet (per-claim rows with currency-formatted cells) and a Monthly sheet (receivables, payments, and revenue grids). 
     * Export financials report to Excel
     */
    async exportCompanyFinancialsExcelRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/company-financials/export/excel`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Generates and downloads a styled Excel workbook containing a Claims sheet (per-claim rows with currency-formatted cells) and a Monthly sheet (receivables, payments, and revenue grids). 
     * Export financials report to Excel
     */
    async exportCompanyFinancialsExcel(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportCompanyFinancialsExcelRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns a comprehensive financial report for the authenticated user\'s company. Includes per-claim financial rows and monthly breakdowns for receivables, payments, and revenue – all grouped by claim creation month. 
     * Get aggregated financials report
     */
    async getCompanyFinancialsReportRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyFinancialsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/company-financials`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyFinancialsResponseFromJSON(jsonValue));
    }

    /**
     * Returns a comprehensive financial report for the authenticated user\'s company. Includes per-claim financial rows and monthly breakdowns for receivables, payments, and revenue – all grouped by claim creation month. 
     * Get aggregated financials report
     */
    async getCompanyFinancialsReport(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyFinancialsResponse> {
        const response = await this.getCompanyFinancialsReportRaw(initOverrides);
        return await response.value();
    }

}
